
import { useState } from "react";
import { User, UserRole } from "@/lib/types";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { UserRoleBadge } from "./UserRoleBadge";

interface AddRoleDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedUser: User | null;
  onAddRole: (role: UserRole) => Promise<void>;
  isPending: boolean;
}

export function AddRoleDialog({ 
  open, 
  onOpenChange, 
  selectedUser, 
  onAddRole, 
  isPending 
}: AddRoleDialogProps) {
  const [newRoleForUser, setNewRoleForUser] = useState<UserRole>("USER");
  const allRoles: UserRole[] = ["USER", "ADMIN", "DEVELOPER", "TESTER"];

  const handleAddRole = async () => {
    if (newRoleForUser) {
      await onAddRole(newRoleForUser);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Role to {selectedUser?.name || selectedUser?.email}</DialogTitle>
          <DialogDescription>
            Select a role to add to this user
          </DialogDescription>
        </DialogHeader>
        <Select 
          value={newRoleForUser} 
          onValueChange={(value) => setNewRoleForUser(value as UserRole)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select a role" />
          </SelectTrigger>
          <SelectContent>
            {allRoles.map(role => (
              <SelectItem key={role} value={role}>
                <div className="flex items-center">
                  <UserRoleBadge role={role} />
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <DialogFooter>
          <Button 
            onClick={handleAddRole} 
            disabled={isPending}
          >
            {isPending ? "Adding..." : "Add Role"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
